import type { ReactNode } from 'react';
import type { LucideIcon } from 'lucide-react';
import { ComparedReplyBody, ComparedReplyLabel, type ComparedReplyBodyProps } from './compared-reply';
import { replySideIcon, type ReplySide } from './reply-side';

interface ComparedReplyView {
  icon: LucideIcon;
  label: ReactNode;
  body: ReactNode;
}

/** The compared turn's parts, for a surface to place in its own row. */
export const comparedReplyView = (
  side: ReplySide,
  input: ComparedReplyBodyProps & { at?: string }
): ComparedReplyView => ({
  icon: replySideIcon(side),
  label: <ComparedReplyLabel requestId={input.requestId} at={input.at} authored={input.authored} />,
  body: <ComparedReplyBody {...input} />,
});
